export enum CommissioningTypeEnum {
  commissioning = 'Inbetriebnahme',
  extension = 'Erweiterung',
  change = 'Änderung',
  decommissioning = 'Außerbetriebnahme'
}

export enum FeederTypeEnum {
  PhotoVoltaic = 'PhotoVoltaic',
  Wind = 'Wind',
  Water = 'Water',
  CoGenerationBioGas = 'CoGenerationBioGas',
  CoGenerationNaturalGas = 'CoGenerationNaturalGas',
  Others = 'Others'
}

// Todo: refactor areatypes
/**
 * Wird für alle Order-Requests verwendet?
 * + NewsFeed
 * + disabledAreaTypes in Ausweis-Konfig
 */
export enum AllAreaEnum {
  Power = 'Power',
  Gas = 'Gas',
  Water = 'Water',
  Heat = 'Heat',
  LWL = 'LWL',
  LWLK = 'LWLK',
  WasteWater = 'WasteWater',
  LocalHeat = 'LocalHeat'
}

/**
 * Wird für alle Inbetriebnahmen verwendet?
 */
export enum AllAreaTypeEnum {
  POWER = 'POWER',
  GAS = 'GAS',
  WATER = 'WATER',
  HEAT = 'HEAT',
  DISTRICTHEAT = 'DISTRICTHEAT',
  LWL = 'LWL',
  LWLK = 'LWLK',
  WASTEWATER = 'WASTEWATER',
  LOCALHEAT = 'LOCALHEAT'
}

// @ts-ignore
export const AreaDisplayName = {
  [AllAreaEnum.Power]: 'Strom',
  [AllAreaEnum.Gas]: 'Gas',
  [AllAreaEnum.Water]: 'Wasser',
  // [AllAreaEnum.Heat]: 'Fernwärme',
  [AllAreaEnum.Heat]: 'Fernwärme',
  [AllAreaEnum.LWL]: 'Leerrohr',
  [AllAreaEnum.LWLK]: 'Glasfaser',
  [AllAreaEnum.WasteWater]: 'Abwasser',
  [AllAreaEnum.LocalHeat]: 'Nahwärme'
};
export const AreaTypeDisplayName = {
  [AllAreaTypeEnum.POWER]: 'Strom',
  [AllAreaTypeEnum.GAS]: 'Gas',
  [AllAreaTypeEnum.WATER]: 'Wasser',
  // [AllAreaTypeEnum.HEAT]: 'Fernwärme',
  [AllAreaTypeEnum.DISTRICTHEAT]: 'Fernwärme',
  [AllAreaTypeEnum.LWL]: 'Leerrohr',
  [AllAreaTypeEnum.LWLK]: 'Glasfaser',
  [AllAreaTypeEnum.WASTEWATER]: 'Abwasser',
  [AllAreaTypeEnum.LOCALHEAT]: 'Nahwärme'
};
// Todo: refactor areatypes
export const AreaTypeEnum = {
  POWER: AllAreaTypeEnum.POWER,
  GAS: AllAreaTypeEnum.GAS,
  WATER: AllAreaTypeEnum.WATER,
  DISTRICTHEAT: AllAreaTypeEnum.DISTRICTHEAT,
  HEAT: AllAreaTypeEnum.HEAT
} as const;
export type AreaTypeEnum = (typeof AreaTypeEnum)[keyof typeof AreaTypeEnum];

// Für Displayname-Mapping siehe CommissioningPowerActionTypeEnum
export enum ActionTypeEnum {
  commissioning = 'commissioning',
  extension = 'extension',
  change = 'change',
  decommissioning = 'decommissioning',
  sealing = 'sealing',
  changeCommunicate = 'changeCommunicate',
  tariffControlInstall = 'tariffControlInstall',
  tariffControlRemove = 'tariffControlRemove',
  tariffControlChange = 'tariffControlChange',
  recommissioning = 'recommissioning',
  temporaryRecommissioning = 'temporaryRecommissioning',
  temporaryPower = 'temporaryPower'
}

export enum CommonStatusEnum {
  Incomplete = 'Incomplete',
  Requested = 'Requested',
  UnderReview = 'UnderReview',
  ReviewCompleted = 'ReviewCompleted',
  Approved = 'Approved',
  Completed = 'Completed',
  ReadyToApprove = 'ReadyToApprove',
  Error = 'Error',
  FeedbackNeeded = 'FeedbackNeeded',
  InstallationCompleted = 'InstallationCompleted'
}

export enum CommissioningStatus {
  ChimneySweepConfirmationRequested = 'ChimneySweepConfirmationRequested',
  PendingAppointment = 'PendingAppointment',
  Error = 'Error',
  DefectReported = 'DefectReported',
  FeedbackNeededByChimneySweep = 'FeedbackNeededByChimneySweep',
  WaitingForOrder = 'WaitingForOrder',
  Commissioned = 'Commissioned',
  TechnicalReview = 'TechnicalReview',
  NAVSent = 'NAVSent'
}

export const CommissioningStatusEnum = {
  ...CommonStatusEnum,
  ...CommissioningStatus
};

export enum SupplyAppointmentStatusEnum {
  Pending = 'Pending',
  Agreed = 'Agreed',
  Rejected = 'Rejected'
}

export enum SupplyAppointmentPartDayStatusEnum {
  Morning = 'Morning',
  Afternoon = 'Afternoon'
}

export enum CommissioningPowerActionType {
  Installation = 'Installation',
  Disassembly = 'Disassembly',
  Change = 'Change'
}

export enum CommissioningPowerFixingType {
  OnePoint = 'OnePoint',
  Three = 'Three',
  Unnecessary = 'Unnecessary'
}

export enum CommissioningPowerMeterType {
  AlternatingMeter = 'AlternatingMeter',
  ThreePhaseMeter = 'ThreePhaseMeter',
  MultyTariffMeter = 'MultyTariffMeter',
  LoadMeter = 'LoadMeter',
  BidirectionalMeter = 'BidirectionalMeter',
  TransformerMeter = 'TransformerMeter',
  MaximunRateMeter = 'MaximunRateMeter',
  PrepaidMeter = 'PrepaidMeter',
  iMSys = 'iMSys',
  AlternatingMeterBidirectional = 'AlternatingMeterBidirectional',
  ThreePhaseMeterBidirectional = 'ThreePhaseMeterBidirectional',
  PartialIndirectMetering = 'PartialIndirectMetering',
  PartialIndirectMeteringTemporary = 'PartialIndirectMeteringTemporary',
  PartialIndirectMeteringBidirectional = 'PartialIndirectMeteringBidirectional',
  PartialIndirectMeteringRLM = 'PartialIndirectMeteringRLM',
  PartialIndirectMeteringRLMTemporary = 'PartialIndirectMeteringRLMTemporary',
  PartialIndirectMeteringBidirectionalRLM = 'PartialIndirectMeteringBidirectionalRLM',
  IndirectMetering = 'IndirectMetering',
  IndirectMeteringBidirectional = 'IndirectMeteringBidirectional'
}

export enum CommissioningPowerFacilityType {
  ConstructionSite = 'ConstructionSite',
  Flat = 'Flat',
  House = 'House',
  Business = 'Business',
  CommunityFacilities = 'CommunityFacilities',
  Others = 'Others'
}

export enum CommissioningPowerDeviceType {
  ChargingDeviceKvA = 'ChargingDeviceKvA',
  ChargingDeviceKW = 'ChargingDeviceKW',
  InstantWaterHeater = 'InstantWaterHeater',
  GenerationPlan = 'GenerationPlan',
  ElectricHeating = 'ElectricHeating'
}

export enum CommissioningGasDeviceType {
  Boiler = 'Heizkessel',
  Stove = 'Herd',
  Others = 'Sonstiges'
}

export enum CommissioningTariffControlEnum {
  Required = 'Benötig',
  AlreadyAvailable = 'Vorhanden',
  Removed = 'Ausgebaut'
}

export enum CommissioningDistrictHeatingActionTypeEnum {
  oil = 'Öl',
  gas = 'Gas',
  others = 'Sonstige'
}
